<template>
  <div class="w-full h-full flex flex-col py-12px justify-start overflow-auto">

    <div class="masonry" ref="gridRef" :style="{ '--cols': String(cols) }">
      <div v-for="item in resourceList" :key="item.id" class="masonry-item cursor-pointer"
        :class="{ 'span-2': isWide(item.id) }">
        <div class="masonry-content" @click="handleClick(item)">
          <img :src="item.full_preview_url" alt="" class="media" @load="onImgLoad($event, item)" />
        </div>
      </div>
    </div>
    <div v-if="resourceList.length === 0">
      <el-empty description="暂无数据" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
onMounted(() => {
  getList()

})

const props = defineProps({
  id: {
    type: Number,
    default: 0
  }
})
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    getList()
  }
})

const resourceList = ref([])
const gridRef = ref<HTMLElement | null>(null)
const wideMap = ref<Record<string, boolean>>({})
const isWide = (id: any) => !!wideMap.value[id]
const cols = ref(3)
let ro: ResizeObserver | null = null
let useColsWindowListener = false

const updateCols = () => {
  const el = gridRef.value
  if (!el) return
  const w = el.clientWidth
  cols.value = w >= 900 ? 4 : 3
}

const getList = () => {
  getResourceList({
    pageNum: 1, pageSize: 30, file_type: 2, folder_id: props.id
  }).then(res => {
    resourceList.value = res.data.data.items
  })
}

defineExpose({ getList })

// 移除基于 grid 行高的测量逻辑，改用 CSS columns 布局

const onImgLoad = (e: Event, item: any) => {
  const img = e.target as HTMLImageElement
  if (img && img.naturalHeight > 0) {
    wideMap.value[item.id] = img.naturalWidth / img.naturalHeight > 2
  }
}

onMounted(() => {
  updateCols()
  if (typeof ResizeObserver !== 'undefined') {
    ro = new ResizeObserver(() => {
      updateCols()
    })
    ro.observe(gridRef.value as HTMLElement)
  } else {
    window.addEventListener('resize', updateCols)
    useColsWindowListener = true
  }
})
onBeforeUnmount(() => {
  if (ro) ro.disconnect()
  if (useColsWindowListener) window.removeEventListener('resize', updateCols)
})


const handleClick = (item: any) => {
  desginsdk.addElement.createImageElement(item.full_preview_url)
}
</script>

<style lang="scss" scoped>
.masonry {
  column-count: var(--cols);
  column-gap: 8px;
}

.masonry-item {
  break-inside: avoid;
  margin-bottom: 8px;
}

.masonry-content {
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.media {
  width: 100%;
  height: auto;
  display: block;
}

.span-2 {
  -webkit-column-span: all;
  column-span: all;
}
</style>
